import React										from 'react';
import {Route, Routes, useParams}					from 'react-router-dom';

import Header										from '../Header/Header';
import Users										from './Users';
import UserAdd										from './UserAdd';
import UserHRIS										from './UserHRIS';
import Onboarding									from './Onboarding';
import Offboarding									from './Offboarding';

import {useAppSelector}								from '../app/hooks';

import LANGUAGE										from '../ressources/language';

import './Users.css';


function MainDevices() {
	const users = useAppSelector(state => state.companyUsers.data);
	const lang = useAppSelector(state => state.settings.lang);

	const params = useParams();
	const TEXTE = LANGUAGE(lang);
	const MENU_DATA = [
		{value: '', render: TEXTE.header.users.employee},
		{
			value:                  'hris',
			minimizeHeaderNavigate: 'hris',
			minimizeHeaderUrl:      ['hris/google'],
			minimizeHeader:         TEXTE.users.backToHris,
			render:                 TEXTE.header.users.HRIS
		},
		{
			value:             'onboarding',
			minimizeHeaderUrl: ['onboarding/import'],
			minimizeHeader:    TEXTE.users.backToTeam,
			render:            TEXTE.header.users.onboarding
		},
		{
			value:                  'offboarding',
			minimizeHeaderUrl:      ['offboarding/add'],
			minimizeHeaderNavigate: '/users/offboarding',
			minimizeHeader:         TEXTE.users.backToTeam,
			render:                 TEXTE.header.users.offboarding
		}
	];

	return (
		<div className={'globalContainerWithHeader'}>
			<Header
				menu={MENU_DATA}
				menuValue={params['*']}
				badgeText={users.length}
				title={TEXTE.users.title}
			/>

			<Routes>
				<Route path={'/'} element={<Users />} />
				<Route path={'/:idUser'} element={<Users />} />
				<Route path={'/hris'} element={<UserHRIS />} />
				<Route path={'/hris/:view'} element={<UserHRIS />} />
				<Route path={'/onboarding'} element={<Onboarding />} />
				<Route path={'/onboarding/:view'} element={<UserAdd />} />
				<Route path={'/offboarding'} element={<Offboarding />} />
				<Route path={'/offboarding/:view'} element={<Offboarding />} />
			</Routes>
		</div>
	);
}

export default MainDevices;
